import React from "react";

import "../Star.css";

const Star9 = () => {
  return (
    <span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star-half-alt"></span>
    </span>
  );
};

export default Star9;
